import { Component, OnInit } from "@angular/core";
import { ReportService } from "../report.service";

@Component({
	selector: "app-district-caass-usage-full",
	templateUrl: "./district-caass-usage-full.component.html",
	styleUrls: ["./district-caass-usage-full.component.css"],
})
export class DistrictCaassUsageFullComponent implements OnInit {
	constructor(private reportService: ReportService) {}

	OutputTypeID: any = 4;
	OutputTypeList = [
		// {
		// 	ID: 1,
		// 	Desc: ".PDF",
		// },
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		// {
		// 	ID: 5,
		// 	Desc: ".RTF (Rich Text File)",
		// },
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		// {
		// 	ID: 7,
		// 	Desc: ".HTM (Web Page)",
		// },
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 467;
	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {}

	Print() {
		var component = this;
		this.errorMessage = "";

		var strParam = "-1|Active";
		this.isProcessing = true;

		var result = this.reportService.Print(this.ReportID, strParam, 0, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}
}
